import { useTranslation } from 'react-i18next';
import { ServicePage } from './ServicePage';

/**
 * `/status`, the footer's "Stato del servizio": provisional texts, marked as such (`ServicePage`).
 * It does not read the services' health yet, and its note says exactly that, so it never shows a
 * state it has not checked.
 */
export function ServiceStatusPage() {
  const { t } = useTranslation('shell');

  return (
    <ServicePage
      title={t('nav.serviceStatus')}
      summary={t('servicePages.status.summary')}
      note={t('servicePages.status.note')}
      sections={[
        {
          id: 'services',
          title: t('servicePages.status.services.title'),
          paragraphs: [t('servicePages.status.services.body')],
        },
        {
          id: 'disruption',
          title: t('servicePages.status.disruption.title'),
          paragraphs: [t('servicePages.status.disruption.body')],
        },
        {
          id: 'updates',
          title: t('servicePages.status.updates.title'),
          paragraphs: [t('servicePages.status.updates.body')],
        },
      ]}
    />
  );
}
